import React from 'react';
import BooleanStep from './BooleanStep';

export default class OptInRecoveryGate extends React.Component {
  render() {
    return (
      <BooleanStep
        {...this.props}
        labelText={ 'Opt In Recovery' }
      />
    );
  }
}
